import { render, staticRenderFns } from "./CompareExpertiseKAMod.vue?vue&type=template&id=03b5081a"
import script from "./CompareExpertiseKAMod.vue?vue&type=script&lang=js"
export * from "./CompareExpertiseKAMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports